import { Button, Flex, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"

import Private from "../../../../Components/Private"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import { formatCurrency } from "../../../../Utils/utils"
import {
  referralColorMap,
  referralStatusTooltip,
  referralTagBgColorMap,
  referralTextMap
} from "../../utils/constants"

const { Text } = Typography

const onUserCell = (record) => {
  return {
    rowSpan: record?.userRowSpan
  }
}

export const columns = ({ t, data, handleClickAlerts, theme }) => {
  const emailList = [...data]?.map(({ user_email }) => user_email)

  return [
    {
      key: "user_email",
      title: "User email",
      dataIndex: "user_email",
      onCell: onUserCell,
      render: (_) => (_ ? <Private>{_}</Private> : "—")
    },
    {
      key: "created",
      title: "Date",
      dataIndex: "created",
      render: (_) => {
        const date = dayjs(_) // or any date like dayjs("2025-11-24")
        const formatted = date.format("DD/MM/YYYY")
        return <Text>{_ ? formatted : "—"}</Text>
      }
    },
    {
      key: "business_account",
      title: (state) =>
        titleSortFilters({
          title: "User BA",
          stateData: state,
          key: "business_account"
        }),
      dataIndex: "business_account",
      render: (_) => (_ ? <Private>{_}</Private> : "—")
    },
    {
      key: "status",
      title: (state) =>
        titleSortFilters({
          title: "BA status",
          stateData: state,
          key: "status"
        }),
      dataIndex: "status",
      render: (_) => {
        const bgColor = theme === "dark" ? referralColorMap[_] : referralTagBgColorMap[_]
        const textColor = theme === "dark" ? referralTagBgColorMap[_] : referralColorMap[_]

        const tooltipText = referralStatusTooltip[_] ?? _

        if (!_) return "—"
        return (
          <Tag key={_} style={{ background: bgColor }} className={`newTagStyle referral`}>
            <Flex gap={8} align="center">
              <Text style={{ color: textColor }}>{_ ? referralTextMap[_] : "—"}</Text>
              <Tooltip title={tooltipText}>
                <div className="text-with-icon">
                  <Icon
                    color={textColor}
                    type="circle_outlined_info"
                    style={{ fontSize: 16, color: "#7A7A83" }}
                  />
                </div>
              </Tooltip>
            </Flex>
          </Tag>
        )
      }
    },
    {
      key: "alerts",
      title: (state) =>
        titleSortFilters({
          title: "Alerts",
          stateData: state,
          key: "alerts"
        }),
      dataIndex: "alerts",
      render: (_, item) => (
        <Button
          onClick={() => handleClickAlerts(item?.id)}
          type="link"
          disabled={!item?.business_account}
        >
          {_ ? _ : "0"}
        </Button>
      )
    },
    {
      key: "reward_amount",
      title: (state) =>
        titleSortFilters({
          title: "Total Reward",
          stateData: state,
          key: "reward_amount"
        }),
      dataIndex: "reward_amount",
      render: (_) => formatCurrency(_ / 100)
    }
  ]
}
